/**
 * @author Wilson && Juan Pablo
 * @class Ruc
 */

enum DataType {
  JuridicPerson = 20,
  NaturalPerson = 10,
  NaturalPersonAdditional = 15,
  NaturalPersonAdditionalTwo = 17,
  FIXED_FACTOR = '5432765432',
  TOTAL_DIGITS_RUC = 11
}

const VALID_DIGITS = [
  DataType.JuridicPerson,
  DataType.NaturalPerson,
  DataType.NaturalPersonAdditional,
  DataType.NaturalPersonAdditionalTwo
];

export default class Ruc {

  public static isValid(value: string): boolean {
      if(!value){
          return false;
      }
      const digitTypePersonInput = value.substr(0, 2);
      if(!Number(value)) {
          return false;
      }
      if(this.isValidDigitTypePerson(Number(digitTypePersonInput))) {
          let checkDigit = value.substr(-1);
          let summation = this.totalSumationDigits(value);
          let rest = summation % DataType.TOTAL_DIGITS_RUC;
          let identifier = DataType.TOTAL_DIGITS_RUC - rest;
          return identifier.toString().substr(-1) === checkDigit && value.length === DataType.TOTAL_DIGITS_RUC;
      }
      return false;
  }

  private static totalSumationDigits(value: string): number {
      return this.summationDigits(this.multiplicationByFactor(value));
  }

  private static summationDigits(foo: number[]): number {
      let sum: number = 0;
      for(let i = 0; i < 10; i++) {
          sum+=foo[i];
      }
      return sum;
  }

  private static multiplicationByFactor(value: string): number[] {
      let digitsMultiplication = [];
      for(let i = 0; i < 10; i++) {
          let item = Number(value.substr(i, 1)) * Number(DataType.FIXED_FACTOR.substr(i, 1));
          digitsMultiplication.push(item);
      }
      return digitsMultiplication;
  }

  private static isValidDigitTypePerson(value: number): boolean {
      return VALID_DIGITS.indexOf(value) !== -1 ? true : false;
  }

}
